<template>
	<v-dialog
		v-model="dialog"
		max-width="800"
		v-bind="$attrs"
	>
		<template
			v-for="(_, slot) of $slots"
			#[slot]="scope"
		>
			<slot
				:name="slot"
				v-bind="scope"
			/>
		</template>
		<v-card>
			<v-card-title>
				<translate>
					Order Review
				</translate>
			</v-card-title>
			<v-card-text>
				<v-form>
					<v-container>
						<v-row>
							<v-col>
								<v-text-field
									variant="outlined"
									:model-value="nameFirst"
									:label="$gettext('First Name')"
									:disabled="!nameFirst"
									readonly
									hide-details
								/>
							</v-col>
							<v-col>
								<v-text-field
									variant="outlined"
									:model-value="fullLastName"
									:label="$gettext('Last Name')"
									readonly
									hide-details
								/>
							</v-col>
							<v-col>
								<v-text-field
									:model-value="birthDay"
									:label="$gettext('Date of Birth')"
									variant="outlined"
									readonly
									hide-details
								/>
							</v-col>
							<v-col>
								<a :href="`/bo/orders/view?id=${orderId}`">
									<v-text-field
										:model-value="orderkey"
										:label="$gettext('Orderkey')"
										variant="outlined"
										readonly
										hide-details
									/>
								</a>
							</v-col>
						</v-row>
						<v-container
							v-if="showReports"
							class="px-0"
						>
							<verifai-fields
								v-if="step === 1 && !(verifaiReport === 'User not found in Verifai report')"
								v-model="verifaiReport"
								:name-first="nameFirst"
								:name-last="nameLast"
								:birth-day="birthDay"
							/>
							<ccbr-fields
								v-model="ccbrReport"
								:show="verifaiReport === 'User not found in Verifai report' || step === 2"
								:name-last="nameLast"
								:infix="infix"
								:birth-day="birthDay"
							/>
						</v-container>
					</v-container>
				</v-form>
			</v-card-text>
			<v-card-actions>
				<v-spacer />
				<confirm-dialog
					:title="$gettext('Deny')"
					@confirm="updateOrder(false)"
				>
					<template #activator="{ props }">
						<v-btn
							v-bind="props"
							color="error"
							variant="text"
						>
							<translate>
								Deny
							</translate>
						</v-btn>
					</template>
				</confirm-dialog>
				<confirm-dialog
					v-if="verifaiReport === 'User not found in Verifai report' || step === 2 || ccbrReport === 'User not found in CCBR'"
					:title="$gettext('Approve')"
					:text="$gettext('This action will activate this users subscription. Are you sure?')"
					@confirm="updateOrder(true)"
				>
					<template #activator="{ props }">
						<v-btn
							v-bind="props"
							color="primary"
							variant="text"
						>
							<translate>
								Approve
							</translate>
						</v-btn>
					</template>
				</confirm-dialog>
				<v-btn
					v-else
					color="primary"
					variant="text"
					@click="step = 2"
				>
					<translate>Next</translate>
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import {
	axios,
} from '../../services/axios-service';
import {
	displayError,
} from 'laravel-front-library';
import ConfirmDialog from '../molecules/ConfirmDialog.vue';
export default {
	name: 'ReviewDialog',
	components: {
		ConfirmDialog
	},
	props: {
		value: {
			type: Boolean,
			default: false
		},

		nameFirst: {
			type: String,
			default: null,
		},
		nameLast: {
			type: String,
			required: true,
		},
		birthDay: {
			type: String,
			required: true,
		},
		infix: {
			type: String,
			default: null,
		},
		orderrowId: {
			type: Number,
			required: true,
		},
		orderId: {
			type: Number,
			required: true,
		},
		orderkey: {
			type: Number,
			required: true,
		}
	},

	emits: ['input',],

	data () {
		return {
			dialog: false,
			reportLoading: true,
			step: 1,
			showReports: false,
			verifaiReport: null,
			ccbrReport: null,
		};
	},

	computed: {
		fullLastName () {
			return this.infix ? `${this.infix} ${this.nameLast}` : this.nameLast;
		}
	},

	watch: {
		dialog (value) {
			this.step = 1;
			if (value) {
				this.showReports = true;
			}
		}
	},

	methods: {
		displayError,

		/**
		 * @param {string} dateString full ISO date string
		 * @returns {string} YYYY-MM-DD date string
		 */
		getDate (dateString) {
			const date = new Date(dateString);

			return `${date.getFullYear()}-${('0' + (date.getMonth() + 1)).slice(-2)}-${('0' + date.getDate()).slice(-2)}`;
		},

		/**
		 * Update the users order
		 *
		 * @param {boolean} isAccepted order is accepted or denied
		 * @returns {void}
		 */
		updateOrder (isAccepted) {
			const data = new FormData();

			data.set('orderrowId', this.orderrowId);
			data.set('accepted', isAccepted);

			axios.post('/bo/pending/update', data).catch((error) => {
				displayError(error);
			}).finally(() => {
				this.$emit('input');
				this.dialog = false;
			});
		}
	}
};
</script>

<style scoped>

</style>
